<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_323" data-name="Group 323" transform="translate(-595.143 -280.286)">
    <circle id="Ellipse_84" data-name="Ellipse 84" cx="35.201" cy="35.201" r="35.201" transform="translate(595.143 280.286)" fill="#fff"/>
    <g id="Group_146" data-name="Group 146" transform="translate(0 -850.394)">
      <rect id="Rectangle_103" data-name="Rectangle 103" width="9.32" height="11.73" transform="matrix(0.867, 0.498, -0.498, 0.867, 624.325, 1149.552)" fill="#1a1818"/>
      <line id="Line_41" data-name="Line 41" x2="12.198" y2="7.009" transform="translate(614.61 1161.692)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      <line id="Line_42" data-name="Line 42" x2="12.198" y2="7.009" transform="translate(624.07 1145.23)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      <line id="Line_43" data-name="Line 43" x2="23.921" y2="13.746" transform="translate(631.466 1160.172)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      <line id="Line_44" data-name="Line 44" x2="25.627" transform="translate(605.839 1179.565)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      <line id="Line_45" data-name="Line 45" x2="21.279" transform="translate(608.013 1174.696)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_03_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_03_02.vue